(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════════════════
     LIVE CATALOGUE — emitted by Liquid from the "Pick Your Vehicle"
     collection + the Universal listing. Handles, option names and variant
     ids are whatever Shopify says right now.
     ══════════════════════════════════════════════════════════════════════ */
  var CATALOGUE = window.NVBS_CATALOGUE || {};

  var UNIVERSAL_HANDLE = 'universal-hitch-mounted-rear-bar';
  var CDN = 'https://cdn.shopify.com/s/files/1/0595/8801/8265/files/';

  /* ══════════════════════════════════════════════════════════════════════
     THE VEHICLE LIST — the only hand-maintained thing in this file.
     handle: null  ->  no named listing, falls through to the Universal.
     ⚠️ NOT yet verified against brain-fitment.md.

     25 Aug 2026 — Prado 150 given its own listing (was null -> Universal);
     Ranger + Ranger Raptor repointed off the Dual Cab Ute listing to the
     Ford Ranger listing, matching the home + Pick Your Vehicle grids and
     the 3-step picker in novaa-collection.js.
     ══════════════════════════════════════════════════════════════════════ */
  var VEHICLES = {
    TOYOTA: [
      { model: 'LandCruiser 300 Series', handle: '300-series-landcruiser-hitch-mounted-rear-bar-alternative' },
      { model: 'LandCruiser 200 Series', handle: '200s-lc-hitch-mounted-rear-bar' },
      { model: 'Prado 250 Series',       handle: 'toyota-250prado-hitch-mounted-rear-bar' },
      { model: 'Prado 150 Series',       handle: 'toyota-150prado-hitch-mounted-rear-bar' },
      { model: 'LandCruiser 70 Series',  handle: null },
      { model: 'HiLux',                  handle: 'dual-cab-ute-hitch-mounted-rear-bar' },
      { model: 'HiAce',                  handle: 'toyota-hiace-hitch-mounted-rear-gear' }
    ],
    FORD: [
      { model: 'Everest',       handle: 'ford-everest-hitch-mounted-rear-bar-1' },
      { model: 'Ranger',        handle: 'ford-ranger-hitch-mounted-rear-bar' },
      { model: 'Ranger Raptor', handle: 'ford-ranger-hitch-mounted-rear-bar' }
    ],
    ISUZU: [
      { model: 'MU-X',  handle: 'isuzu-mu-x-hitch-mounted-rear-bar' },
      { model: 'D-MAX', handle: 'dual-cab-ute-hitch-mounted-rear-bar' }
    ],
    NISSAN: [
      { model: 'Patrol', handle: 'nissan-patrol-hitch-mounted-rear-bar' },
      { model: 'Navara', handle: 'dual-cab-ute-hitch-mounted-rear-bar' }
    ],
    MAZDA:        [{ model: 'BT-50', handle: 'dual-cab-ute-hitch-mounted-rear-bar' }],
    MITSUBISHI:   [{ model: 'Triton', handle: 'dual-cab-ute-hitch-mounted-rear-bar' },
                   { model: 'Pajero Sport', handle: null }],
    VOLKSWAGEN:   [{ model: 'Amarok', handle: 'dual-cab-ute-hitch-mounted-rear-bar' },
                   { model: 'Transporter', handle: 'toyota-hiace-hitch-mounted-rear-gear' }],
    SSANGYONG:    [{ model: 'Musso', handle: 'dual-cab-ute-hitch-mounted-rear-bar' }],
    JEEP:         [{ model: 'Wrangler', handle: null }, { model: 'Gladiator', handle: null }],
    'LAND ROVER': [{ model: 'Defender', handle: null }, { model: 'Discovery', handle: null }],
    LEXUS:        [{ model: 'LX Series', handle: null }, { model: 'GX Series', handle: null }],
    SUZUKI:       [{ model: 'Jimny', handle: null }],
    RAM:          [{ model: '1500', handle: null }, { model: '2500 / 3500', handle: null }],
    OTHER:        [{ model: 'Something else', handle: null }]
  };
  var POPULAR = ['TOYOTA', 'FORD', 'ISUZU', 'NISSAN', 'MAZDA', 'MITSUBISHI'];

  var GEAR = [
    { id: '4x4', value: 'Wheel Holder + Cargo Carrier', short: 'Spare wheel + gear', rec: true,
      img: CDN + 'Drivers_Swing_4x4_bs.jpg?width=600',
      alt: 'Novaa swing arm carrying a spare wheel on one side and a cargo carrier on the other',
      items: ['Swing arm', 'Wheel holder for your spare', 'One cargo carrier'] },
    { id: 'DC', value: 'Dual Cargo Carrier', short: 'Maximum cargo',
      img: CDN + 'Drivers_Swing_CCBS_w_Gear.jpg?width=600',
      alt: 'Novaa swing arm carrying two cargo carriers loaded with storage boxes',
      items: ['Swing arm', 'Two cargo carriers', 'Spare stays where it is'] }
  ];
  var SWING = [
    { id: 'D', value: 'Drivers Side', label: 'Drivers Side', rec: true },
    { id: 'P', value: 'Passenger Side', label: 'Passenger Side' }
  ];

  var OPT_GEAR = 'gear setup';
  var OPT_SWING = 'swing open side';

  /* ══════════════════ dom ══════════════════ */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var scope = $('.nvbs-scope');
  if (!scope) return;
  var scrim   = $('.nvbs-scrim', scope);
  var garage  = $('[data-nvbs-garage]', scope);
  var wiz     = $('[data-nvbs-wiz]', scope);
  var gBody   = $('[data-nvbs-garage-body]', scope);
  var gFoot   = $('[data-nvbs-garage-foot]', scope);
  var wBody   = $('[data-nvbs-wiz-body]', scope);
  var wFoot   = $('[data-nvbs-wiz-foot]', scope);
  var wRail   = $('[data-nvbs-rail]', scope);
  var wTitle  = $('[data-nvbs-title]', scope);
  var wSub    = $('[data-nvbs-sub]', scope);

  /* ══════════════════ state ══════════════════ */
  var build = null, hist = [];
  try { build = JSON.parse(localStorage.getItem('nvBuild') || 'null'); } catch (e) {}
  try { hist = JSON.parse(localStorage.getItem('nvBuildHistory') || '[]'); } catch (e) {}
  var draft = {}, step = 1;

  function persist() {
    try {
      localStorage.setItem('nvBuild', JSON.stringify(build));
      localStorage.setItem('nvBuildHistory', JSON.stringify(hist));
    } catch (e) {}
    paintChip();
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function gearOf(b) { for (var i = 0; i < GEAR.length; i++) if (GEAR[i].id === b.gear) return GEAR[i]; return GEAR[0]; }
  function swingOf(b) { for (var i = 0; i < SWING.length; i++) if (SWING[i].id === b.swing) return SWING[i]; return SWING[0]; }

  /* ══════════════════ resolve to a real variant ══════════════════ */
  function resolve(d) {
    var handle = d.veh.handle;
    /* a handle we don't have live data for (unpublished, renamed) falls back to the Universal */
    if (!handle || !CATALOGUE[handle]) handle = UNIVERSAL_HANDLE;
    var prod = CATALOGUE[handle];

    var out = {
      make: d.make, model: d.veh.model, gear: d.gear, swing: d.swing,
      handle: handle, named: d.veh.handle === handle,
      url: '/products/' + handle, variantId: null
    };
    if (!prod || !prod.o) return out;

    var names = prod.o.map(function (n) { return String(n).trim().toLowerCase(); });
    var gi = names.indexOf(OPT_GEAR);
    var si = names.indexOf(OPT_SWING);
    if (gi < 0 || si < 0) return out;

    var wantGear = gearOf(d).value, wantSwing = swingOf(d).value;
    for (var i = 0; i < prod.v.length; i++) {
      var v = prod.v[i];
      if (String(v.t[gi]).trim() === wantGear && String(v.t[si]).trim() === wantSwing) {
        out.variantId = v.id;
        out.url = '/products/' + handle + '?variant=' + v.id;
        break;
      }
    }
    return out;
  }

  /* ══════════════════ swing diagram — top down, nose up ══════════════════
     Drivers: arm out from the rear RIGHT at 5 o'clock. Passenger mirrors it. */
  function swingIcon(side) {
    var g = side === 'P' ? '<g transform="translate(126,0) scale(-1,1)">' : '<g>';
    return '<svg width="140" height="151" viewBox="0 0 126 136" fill="none" aria-hidden="true">' + g +
      '<rect x="33" y="20" width="7" height="16" rx="2" fill="#14171a"/>' +
      '<rect x="80" y="20" width="7" height="16" rx="2" fill="#14171a"/>' +
      '<rect x="33" y="62" width="7" height="16" rx="2" fill="#14171a"/>' +
      '<rect x="80" y="62" width="7" height="16" rx="2" fill="#14171a"/>' +
      '<rect x="38" y="6" width="44" height="86" rx="13" fill="#2a2e2f"/>' +
      '<rect x="44" y="20" width="32" height="12" rx="3" fill="#6b6e6f" opacity=".55"/>' +
      '<rect x="44" y="36" width="32" height="22" rx="3" fill="#14171a" opacity=".35"/>' +
      '<rect x="44" y="62" width="32" height="11" rx="3" fill="#6b6e6f" opacity=".55"/>' +
      '<rect x="56" y="92" width="8" height="6" rx="1" fill="#14171a"/>' +
      '<path d="M44 97 H76" stroke="#c9beb9" stroke-width="3" stroke-linecap="round" stroke-dasharray="4 4"/>' +
      '<path d="M76 96 L98 128" stroke="#937962" stroke-width="6" stroke-linecap="round"/>' +
      '<circle cx="76" cy="96" r="3.5" fill="#14171a"/>' +
      '<rect x="-9" y="-7" width="18" height="14" rx="2" fill="#14171a" transform="translate(99,129) rotate(-34)"/>' +
      '</g></svg>';
  }

  /* ══════════════════ chip ══════════════════ */
  function paintChip() {
    $$('.nvbs-chip').forEach(function (c) {
      var lbl = $('[data-nvbs-chip-lbl]', c),
          val = $('[data-nvbs-chip-val]', c),
          dot = $('[data-nvbs-chip-dot]', c);
      if (build) {
        c.classList.add('is-set');
        if (lbl) lbl.textContent = 'My build';
        if (val) val.textContent = build.make + ' ' + build.model;
        if (dot) dot.hidden = false;
        c.setAttribute('aria-label', 'My build: ' + build.make + ' ' + build.model);
      } else {
        c.classList.remove('is-set');
        if (lbl) lbl.textContent = 'Your build';
        if (val) val.textContent = 'Select your vehicle';
        if (dot) dot.hidden = true;
        c.setAttribute('aria-label', 'Select your vehicle');
      }
    });
  }

  /* ══════════════════ open / close ══════════════════ */
  function lock(on) {
    document.body.classList.toggle('nvbs-locked', on);
    document.body.style.overflow = on ? 'hidden' : '';
  }
  function closeAll() {
    scrim.classList.remove('is-open');
    garage.classList.remove('is-open');
    wiz.classList.remove('is-open');
    lock(false);
  }
  function openGarage() {
    scrim.classList.add('is-open');
    wiz.classList.remove('is-open');
    garage.classList.add('is-open');
    lock(true);
    renderGarage();
  }
  function startWizard() {
    draft = {}; step = 1;
    garage.classList.remove('is-open');
    scrim.classList.add('is-open');
    wiz.classList.add('is-open');
    lock(true);
    renderWiz();
  }

  /* ══════════════════ garage ══════════════════ */
  function renderGarage() {
    if (!build) {
      gFoot.innerHTML = '<button class="nvbs-btn" type="button" data-nvbs-start>Start my build</button>';
      gBody.innerHTML =
        '<div class="nvbs-empty">' +
        '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#14171a" stroke-width="1.4">' +
        '<path d="M3 10.5 12 4l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><path d="M7 21v-6h10v6"/></svg>' +
        '<h3>Nothing built yet</h3>' +
        '<p>Four questions and we&rsquo;ll have your exact setup &mdash; vehicle, gear, and which way it swings.</p>' +
        '</div>';
      paintPrev();
      return;
    }
    gFoot.innerHTML =
      '<button class="nvbs-btn nvbs-btn--ghost" type="button" style="flex:0 0 38%" data-nvbs-start>Change</button>' +
      '<button class="nvbs-btn" type="button" data-nvbs-go>View my build &rarr;</button>';
    gBody.innerHTML =
      '<div class="nvbs-gcard">' +
        '<div class="nvbs-gtop"><span>&#10003; Active build</span>' +
        '<button class="nvbs-del" type="button" data-nvbs-clear aria-label="Remove build">Remove</button></div>' +
        '<div class="nvbs-gmain"><h4>' + esc(build.make + ' ' + build.model) + '</h4></div>' +
        '<div class="nvbs-gspec">' +
          '<div><span>Gear setup</span><b>' + esc(gearOf(build).short) + '</b></div>' +
          '<div><span>Swing open side</span><b>' + esc(swingOf(build).label) + '</b></div>' +
        '</div>' +
      '</div>';
    paintPrev();
  }
  function paintPrev() {
    var prev = hist.filter(function (h) { return !build || h.handle + h.gear + h.swing !== build.handle + build.gear + build.swing; }).slice(0, 4);
    if (!prev.length) return;
    gBody.insertAdjacentHTML('beforeend',
      '<div class="nvbs-gprev">Previously configured</div>' +
      prev.map(function (h, i) {
        return '<button class="nvbs-gprevrow" type="button" data-nvbs-prev="' + i + '">' +
          '<em>' + esc(h.make + ' ' + h.model) + '</em>' +
          '<small>' + esc(gearOf(h).short + ' · ' + (h.swing === 'D' ? 'Drivers' : 'Passenger')) + '</small></button>';
      }).join(''));
  }

  /* ══════════════════ wizard ══════════════════ */
  var STEPS = [
    { n: '01', l: 'Make',  v: function (d) { return d.make; } },
    { n: '02', l: 'Model', v: function (d) { return d.veh && d.veh.model; } },
    { n: '03', l: 'Gear',  v: function (d) { return d.gear && gearOf(d).short; } },
    { n: '04', l: 'Swing', v: function (d) { return d.swing && swingOf(d).label.split(' ')[0]; } }
  ];

  function renderWiz() {
    wRail.innerHTML = STEPS.map(function (s, i) {
      var n = i + 1, cls = n < step ? 'is-done' : (n === step ? 'is-now' : ''), val = s.v(draft);
      return '<div class="nvbs-rail__s ' + cls + '">' +
        '<div class="nvbs-rail__dot">' + (n < step ? '&#10003;' : s.n) + '</div>' +
        '<div class="nvbs-rail__lbl">' + s.l + '</div>' +
        '<div class="nvbs-rail__val">' + esc(val || (n === step ? 'Select' : '')) + '</div></div>';
    }).join('');

    wFoot.hidden = true;
    wBody.scrollTop = 0;
    var bk = step > 1 ? '<button class="nvbs-back" type="button" data-nvbs-back>&lsaquo; Previous step</button>' : '';

    if (step === 1) {
      wTitle.textContent = 'Select your vehicle';
      wSub.textContent = 'So we spec the right build';
      var rest = Object.keys(VEHICLES).filter(function (m) { return POPULAR.indexOf(m) < 0; });
      var rowFor = function (m) {
        return '<button class="nvbs-row" type="button" data-nvbs-make="' + esc(m) + '">' + esc(m) + '</button>';
      };
      wBody.innerHTML =
        '<input class="nvbs-search" type="search" data-nvbs-search placeholder="Search your vehicle&rsquo;s make" aria-label="Search makes">' +
        '<div data-nvbs-makes>' +
          '<div class="nvbs-seclbl">Popular makes</div>' + POPULAR.map(rowFor).join('') +
          '<div class="nvbs-seclbl">All makes</div>' + rest.map(rowFor).join('') +
        '</div>';

    } else if (step === 2) {
      wTitle.textContent = 'Select your ' + draft.make;
      wSub.textContent = 'Pick the closest match';
      wBody.innerHTML = bk + VEHICLES[draft.make].map(function (v, i) {
        var uni = !v.handle || !CATALOGUE[v.handle];
        return '<button class="nvbs-row" type="button" data-nvbs-model="' + i + '">' + esc(v.model) +
          (uni ? '<span class="nvbs-tag">universal fit</span>' : '') + '</button>';
      }).join('');

    } else if (step === 3) {
      wTitle.textContent = 'What are you carrying?';
      wSub.textContent = 'This decides your gear setup';
      wBody.innerHTML = bk +
        '<div class="nvbs-hint"><b>Same swing arm either way.</b> The difference is what bolts to it ' +
        '&mdash; a wheel holder plus one cargo carrier, or two cargo carriers.</div>' +
        GEAR.map(function (g) {
          return '<button class="nvbs-card' + (draft.gear === g.id ? ' is-sel' : '') + '" type="button" data-nvbs-gear="' + g.id + '">' +
            '<span class="nvbs-split">' +
              '<img class="nvbs-cardimg" src="' + g.img + '" alt="' + esc(g.alt) + '" decoding="async" width="240" height="240">' +
              '<span class="nvbs-cardb">' +
                '<h4>' + esc(g.short) + (g.rec ? '<span class="nvbs-rec">Most popular</span>' : '') + '</h4>' +
                '<span class="nvbs-cardsub">' + esc(g.value) + '</span>' +
                '<ul>' + g.items.map(function (i) { return '<li>' + esc(i) + '</li>'; }).join('') + '</ul>' +
              '</span>' +
            '</span></button>';
        }).join('');

    } else if (step === 4) {
      wTitle.textContent = 'Which way should it swing?';
      wSub.textContent = 'Last question';
      wBody.innerHTML = bk +
        '<div class="nvbs-hint"><b>Most people pick Drivers Side.</b> Awnings usually sit on the ' +
        'passenger side, so swinging away from the awning keeps the camp clear. Same side is fine ' +
        'if you&rsquo;d rather have it that way.</div>' +
        SWING.map(function (s) {
          return '<button class="nvbs-card' + (draft.swing === s.id ? ' is-sel' : '') + '" type="button" data-nvbs-swing="' + s.id + '">' +
            '<span class="nvbs-split">' +
              '<span class="nvbs-carddiag">' + swingIcon(s.id) + '</span>' +
              '<span class="nvbs-cardb"><h4>' + esc(s.label) + (s.rec ? '<span class="nvbs-rec">Default</span>' : '') + '</h4>' +
              '<span class="nvbs-cardsub">Looking down on the vehicle<br>Swings out to the ' +
              (s.id === 'D' ? 'rear right' : 'rear left') + '</span></span>' +
            '</span></button>';
        }).join('');

    } else {
      wTitle.textContent = 'Confirm your build';
      wSub.textContent = 'This is your spec';
      var r = resolve(draft);
      wBody.innerHTML =
        '<button class="nvbs-back" type="button" data-nvbs-back>&lsaquo; Previous step</button>' +
        '<div class="nvbs-cfhero"><span class="nvbs-eyebrow">Your Novaa build</span>' +
        '<h3>' + esc(r.make + ' ' + r.model) + '</h3></div>' +
        '<dl style="margin:0">' +
          '<div class="nvbs-line"><dt>Gear setup</dt><dd>' + esc(gearOf(r).value) + '</dd></div>' +
          '<div class="nvbs-line"><dt>Swing open side</dt><dd>' + esc(swingOf(r).label) + '</dd></div>' +
        '</dl>';
      wFoot.hidden = false;
      wFoot.innerHTML =
        '<button class="nvbs-btn nvbs-btn--ghost" type="button" style="flex:0 0 34%" data-nvbs-start>Restart</button>' +
        '<button class="nvbs-btn" type="button" data-nvbs-create>Create my build &rarr;</button>';
    }
  }

  /* ══════════════════ events (delegated) ══════════════════ */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-nvbs-open],[data-nvbs-close],[data-nvbs-start],[data-nvbs-go],[data-nvbs-clear],[data-nvbs-prev],[data-nvbs-back],[data-nvbs-make],[data-nvbs-model],[data-nvbs-gear],[data-nvbs-swing],[data-nvbs-create]') : null;
    if (!t) return;

    if (t.hasAttribute('data-nvbs-open'))  { e.preventDefault(); openGarage(); return; }
    if (t.hasAttribute('data-nvbs-close')) { e.preventDefault(); closeAll(); return; }
    if (t.hasAttribute('data-nvbs-start')) { e.preventDefault(); startWizard(); return; }
    if (t.hasAttribute('data-nvbs-back'))  { e.preventDefault(); step = Math.max(1, step - 1); renderWiz(); return; }

    if (t.hasAttribute('data-nvbs-go')) {
      e.preventDefault();
      if (build && build.url) window.location.href = build.url;
      return;
    }
    if (t.hasAttribute('data-nvbs-clear')) {
      e.preventDefault(); build = null; persist(); renderGarage(); return;
    }
    if (t.hasAttribute('data-nvbs-prev')) {
      e.preventDefault();
      var pool = hist.filter(function (h) { return !build || h.handle + h.gear + h.swing !== build.handle + build.gear + build.swing; });
      var picked = pool[parseInt(t.getAttribute('data-nvbs-prev'), 10)];
      if (picked) {
        build = picked;
        hist = [build].concat(hist.filter(function (h) { return h.handle + h.gear + h.swing !== build.handle + build.gear + build.swing; })).slice(0, 6);
        persist(); renderGarage();
      }
      return;
    }
    if (t.hasAttribute('data-nvbs-make')) {
      e.preventDefault(); draft.make = t.getAttribute('data-nvbs-make'); draft.veh = null; step = 2; renderWiz(); return;
    }
    if (t.hasAttribute('data-nvbs-model')) {
      e.preventDefault(); draft.veh = VEHICLES[draft.make][parseInt(t.getAttribute('data-nvbs-model'), 10)]; step = 3; renderWiz(); return;
    }
    if (t.hasAttribute('data-nvbs-gear')) {
      e.preventDefault(); draft.gear = t.getAttribute('data-nvbs-gear'); step = 4; renderWiz(); return;
    }
    if (t.hasAttribute('data-nvbs-swing')) {
      e.preventDefault(); draft.swing = t.getAttribute('data-nvbs-swing'); step = 5; renderWiz(); return;
    }
    if (t.hasAttribute('data-nvbs-create')) {
      e.preventDefault();
      build = resolve(draft);
      hist = [build].concat(hist.filter(function (h) { return h.handle + h.gear + h.swing !== build.handle + build.gear + build.swing; })).slice(0, 6);
      persist(); openGarage();
      return;
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.hasAttribute || !e.target.hasAttribute('data-nvbs-search')) return;
    var q = e.target.value.toLowerCase();
    $$('[data-nvbs-makes] .nvbs-row').forEach(function (r) {
      r.style.display = r.getAttribute('data-nvbs-make').toLowerCase().indexOf(q) > -1 ? '' : 'none';
    });
    $$('[data-nvbs-makes] .nvbs-seclbl').forEach(function (l) { l.style.display = q ? 'none' : ''; });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ══════════════════ place the chip in the header ══════════════════
     Runs at end of <body>, so header-group is already parsed. Falls back to
     the fixed pill if .nv-right can't be found (theme edit, editor reload). */
  function placeChip() {
    var chip = $('[data-nvbs-chip]');
    if (!chip) return false;
    var right = document.querySelector('#header-group .nv-right') || document.querySelector('.nv-right');
    if (!right) return false;
    if (chip.parentNode === right) return true;
    chip.classList.remove('nvbs-chip--unplaced', 'nvbs-chip--fallback');
    right.insertBefore(chip, right.firstChild);
    return true;
  }
  /* The chip starts visibility:hidden so it never flashes as a pill before being
     placed. If .nv-right genuinely isn't there, reveal the pill instead. */
  function settleChip() {
    if (placeChip()) return;
    var chip = $('[data-nvbs-chip]');
    if (chip) chip.classList.add('nvbs-chip--fallback');
  }
  settleChip();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', settleChip);
  /* the theme editor re-renders the header section on every setting change */
  document.addEventListener('shopify:section:load', placeChip);

  paintChip();
})();
